import styled from 'styled-components';

import { BUTTON_CONTAINER_TOP_BORDER } from '../constants';

export const ButtonContainer = styled.div`
  background-color: ${Styles.color.white};
  bottom: 0;
  position: relative;
  width: 100%;
  border-top: ${BUTTON_CONTAINER_TOP_BORDER};
`;

export const ButtonContainerShadow = styled.div<{ $boxShadow: boolean }>`
  bottom: 0;
  box-shadow: 0px -4px 4px 0 rgba(0, 0, 0, 0.1);
  left: 0;
  opacity: ${props => (props.$boxShadow ? 1 : 0)};
  pointer-events: none;
  position: absolute;
  top: 0;
  transition: 0.2s opacity linear;
  right: 0;
`;
